import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import { DIGITAL_DIM } from '../../../../../../utils/constantFeatures';
import PropertyPicker from './components/PropertyPicker';
import Checkbox from 'components/shared/StandaloneCheckbox';
import { Trans } from 'react-i18next';

class DigitalDim extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isCheckedLossDimDataLevel: this.isOn(this.props.properties[DIGITAL_DIM.lossDimDataLevel]),
            isCheckedPowerOnLevelOnOff: this.isOn(this.props.properties[DIGITAL_DIM.powerOnLevel]),
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCheckboxes = this.handleChangeCheckboxes.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };
        // this.setState({ dimmingEnabled: v === "1" ? true : false });

        this.props.handleChange(propertyName, v);
    }

    isOn(property) {
        return property != null && property.value !== 'Off' && property.value !== property.valueMeta.off;
    }

    handleChangeCheckboxes(e) {
        const checked = e.target.checked;
        switch (e.target.name) {
            case "lossDimDataLevel":
                // this.props.handleChange(this.props.properties[DIGITAL_DIM.lossDimDataLevel].info.name, !checked ? "Off" : this.props.properties[DIGITAL_DIM.lossDimDataLevel].valueMeta.default);

                let lossDimDataLevel = this.props.properties[DIGITAL_DIM.lossDimDataLevel];
                lossDimDataLevel.value = checked ? this.props.properties[DIGITAL_DIM.lossDimDataLevel].valueMeta.initial : "Off";
                this.handleChange(lossDimDataLevel.info.name, lossDimDataLevel.value);

                this.setState({ isCheckedLossDimDataLevel: checked });
                break;
            case "powerOnLevelOnOff":
                let powerOnLevel = this.props.properties[DIGITAL_DIM.powerOnLevel];
                powerOnLevel.value = checked ? this.props.properties[DIGITAL_DIM.powerOnLevel].valueMeta.initial : "Off";
                this.handleChange(powerOnLevel.info.name, powerOnLevel.value);

                this.setState({ isCheckedPowerOnLevelOnOff: checked });
                break;
            default:
                break;
        }
    }

    render() {

        return (
            <><Row>
                <Col lg={4} md={6} sm={12}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Power_On_Level" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                            <Checkbox
                                name={"powerOnLevelOnOff"}
                                checked={this.state.isCheckedPowerOnLevelOnOff}
                                style={{ margin: "auto 0.5rem" }}
                                onChange={this.handleChangeCheckboxes}
                            />
                            {<Trans i18nKey="Enable_Disable" />}

                            <PropertyPicker
                                disabled={!this.state.isCheckedPowerOnLevelOnOff}
                                property={this.props.properties[DIGITAL_DIM.powerOnLevel]}
                                title={this.props.properties[DIGITAL_DIM.powerOnLevel].info.displayName + ""}
                                margin="0.75rem auto"
                                measureUnit={this.props.properties[DIGITAL_DIM.powerOnLevel].info.unit}
                                min={this.props.properties[DIGITAL_DIM.powerOnLevel].valueMeta.min}
                                max={this.props.properties[DIGITAL_DIM.powerOnLevel].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto", minWidth: '70px' }}
                                titleSize={8}
                                inputSize={2}
                                step={0.5}
                                handleChange={this.handleChange} />

                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={4} md={6} sm={12}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Loss_Dim_Data" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <Checkbox
                                name={"lossDimDataLevel"}
                                checked={this.state.isCheckedLossDimDataLevel}
                                style={{ margin: "auto 0.5rem" }}
                                onChange={this.handleChangeCheckboxes}
                            />
                            {<Trans i18nKey="Enable_Disable" />}

                            <PropertyPicker
                                disabled={!this.state.isCheckedLossDimDataLevel}
                                property={this.props.properties[DIGITAL_DIM.lossDimDataTime]}
                                title={this.props.properties[DIGITAL_DIM.lossDimDataTime].info.displayName + ""}
                                margin="0.75rem auto"
                                measureUnit={this.props.properties[DIGITAL_DIM.lossDimDataTime].info.unit}
                                min={this.props.properties[DIGITAL_DIM.lossDimDataTime].valueMeta.min}
                                max={this.props.properties[DIGITAL_DIM.lossDimDataTime].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto", minWidth: '70px' }}
                                titleSize={8}
                                inputSize={2}
                                step={1}
                                handleChange={this.handleChange} />

                            <PropertyPicker
                                disabled={!this.state.isCheckedLossDimDataLevel}
                                property={this.props.properties[DIGITAL_DIM.lossDimDataLevel]}
                                title={this.props.properties[DIGITAL_DIM.lossDimDataLevel].info.displayName + ""}
                                margin="0.75rem auto"
                                measureUnit={this.props.properties[DIGITAL_DIM.lossDimDataLevel].info.unit}
                                min={this.props.properties[DIGITAL_DIM.lossDimDataLevel].valueMeta.min}
                                max={this.props.properties[DIGITAL_DIM.lossDimDataLevel].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto", minWidth: '70px' }}
                                titleSize={8}
                                inputSize={2}
                                step={0.5}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(DigitalDim);
